import { useEffect, useCallback, useRef } from 'react';

export const useAnimate = (
  animationCallback,
  fps = null
) => {
  const requestRef = useRef(null);
  const timingRef = useRef(0);

  const throttleCallback = useCallback(() => {
    const currentTime = Date.now();
    const elapsed = currentTime - timingRef.current;
    if (fps === null || (elapsed > 1000 / fps)) {
      timingRef.current = currentTime;
      animationCallback(elapsed);
    }
    requestRef.current = requestAnimationFrame(throttleCallback);
  }, [animationCallback, fps]);

  useEffect(() => {
    timingRef.current = Date.now();
    requestRef.current = requestAnimationFrame(throttleCallback);

    return () => {
      cancelAnimationFrame(requestRef.current ?? 0);
    };
  }, [throttleCallback]);
};